import React from "react";
import { ReactComponent as SadIconBig } from "common-assets/assets/images/404.svg";
import { NotFoundCardPropsModel } from "./tools/NotFoundCard.model";
import { Card } from "../Card/Card";
import { ComponentStyled } from "../ComponentStyled/ComponentStyled";
import { Button } from "../Button/Button";
import { Title } from "../Title/Title";
import { Icon } from "../Icon/Icon";

import useStyles from "./NotFoundCard.style";

export const NotFoundCard = ({
  onRedirect,
  title,
  description,
  redirectLinkLabel,
}: NotFoundCardPropsModel) => {
  const c = useStyles({});

  return (
    <div className={c.wrapper} data-testid="NotFoundCard" data-autotestid="NotFoundCard">
      <Card
        fullWidth
        size="big"
        className={c.root}
        data-testid="page-not-found"
        type="ghost"
      >
        <Icon testId="NotFoundCard-icon" className={c.icon}>
          <SadIconBig />
        </Icon>
        <ComponentStyled
          marginTop="24"
          marginBottom="24"
          component={Title}
          componentProps={{
            title,
            description,
            align: "center",
            titleTestid: "NotFoundCard-title",
            descriptionTestid: "NotFoundCard-description",
            titleFontWeight: 'extraBold',
            titleVariant: 'caption',
          }}
        />
        <Button
          onClick={onRedirect}
          testId="NotFoundCard-redirect-link"
          autoTestId="NotFoundCard-redirect-link"
          width="auto"
          disableFullWidthOnMobile={true}
        >
          {redirectLinkLabel}
        </Button>
      </Card>
    </div>
  );
};
